import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ModalImportarArquivoFuncionarioService } from './modal-importar-arquivo-funcionario.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'ngx-modal-importar-arquivo-funcionario',
  templateUrl: './modal-importar-arquivo-funcionario.component.html',
  styleUrls: ['./modal-importar-arquivo-funcionario.component.scss']
})
export class ModalImportarArquivoFuncionarioComponent implements OnInit {

  @Input() emitirCartao: string;
  @Input() inputFile: any;

  public customLogin = null;
  public title = 'Importação Funcionários';
  public subTitle = 'Arquivo enviado com sucesso!';
  public descricao = 'Aguarde até 2 dias úteis para receber a confirmação do cadastro por e-mail.';
  public subDescricao = 'Você pode acompanhar o status da importação acessando o sub menu Acompanhar Importação.'
  constructor(protected ref: NbDialogRef<ModalImportarArquivoFuncionarioComponent>,
    private service: ModalImportarArquivoFuncionarioService) { }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);

  }

  confimar() {
    this.ref.close(true);
  }

  closeModal() {
    this.ref.close(false);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
